export const SEARCH_FILTER_KEY = 'search';
export const DATE_FILTER_KEY = 'date';
export const DATE_RANGE_FILTER_KEY = 'range';
